<section class="home-datos" aria-label="Cifras de neocrédito">
  <div class="home-datos__card">
    <div class="home-datos__item home-datos__item--1">
      <p class="home-datos__value">{{ content.usuariosValue }}</p>
      <p class="home-datos__text">
        de negocios ya<br />
        confían en neocrédito
      </p>
    </div>

    <div class="home-datos__item home-datos__item--logo">
      <img
        class="home-datos__logo"
        [src]="content.bancoldexLogoSrc"
        alt="Bancóldex"
      />
      <p class="home-datos__text">
        asegura y respalda<br />
        el proceso
      </p>
    </div>

    <div class="home-datos__item home-datos__item--3">
      <p class="home-datos__value">{{ content.municipiosValue }}</p>
      <p class="home-datos__text">
        municipios cubiertos<br />
        en Colombia
      </p>
    </div>

    <div class="home-datos__item home-datos__item--4">
      <p class="home-datos__value">{{ content.montoValue }}</p>
      <p class="home-datos__text">
        {{ content.montoTextLine1 }}<br />
        {{ content.montoTextLine2 }}
      </p>
    </div>
  </div>
</section>
